export const CAPACITY_TYPES_FETCHED = 'CAPACITY_TYPES_FETCHED';
export const CAPACITY_TYPE_ADDED = 'CAPACITY_TYPE_ADDED';
export const CAPACITY_TYPE_UPDATE = 'CAPACITY_TYPE_UPDATE';
